



















import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({
  name: 'MainHeader',
})
export default class MainHeader extends Vue {
  @Prop({ type: Array, default: [] }) headerArr!: any;
  @Prop({ type: Boolean, default: false }) showReturn!: false;
  @Prop({ type: Number }) status!: false;

  public returnBack() {
    if (this.status) {
      this.$emit('backTo')
    } else {
      this.$router.back()
    }

  }
  created() {}
}
